import { render, staticRenderFns } from "./ResponsibilitiesWithNoAttachmentsBanner.vue?vue&type=template&id=2f9df68e&scoped=true"
import script from "./ResponsibilitiesWithNoAttachmentsBanner.vue?vue&type=script&setup=true&lang=js"
export * from "./ResponsibilitiesWithNoAttachmentsBanner.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ResponsibilitiesWithNoAttachmentsBanner.vue?vue&type=style&index=0&id=2f9df68e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f9df68e",
  null
  
)

export default component.exports